import { endpointLabels, mapTypes } from "../../../common/utils/enum"
import { getEndpointFromConfig } from "../../../common/utils/helper"
import { fetchAndSetBoundaries } from "../../indicatorProfileSlice"
import { fetchAndSetCentroids } from "../../../common/commonSlice"

export const getBoundariesAction = (boundaryType, endpointList) => {
  let endpointLabel = endpointLabels.MapBoundaries

  if (boundaryType === mapTypes.Region) {
    endpointLabel = endpointLabels.RegionBoundaries
  } else if (boundaryType === mapTypes.Continent) {
    endpointLabel = endpointLabels.ContinentBoundaries
  }

  const mapApiUrl = getEndpointFromConfig(
    endpointList,
    endpointLabel
  )?.apiEndpoint

  if (mapApiUrl) {
    return fetchAndSetBoundaries({
      endpoint: mapApiUrl,
      boundaryType: boundaryType,
    })
  }

  return null
}

export const getCentroidsAction = (endpointList) => {
  const centroidsApiUrl = getEndpointFromConfig(
    endpointList,
    endpointLabels.MapCentroids
  )?.apiEndpoint

  if (centroidsApiUrl) {
    return fetchAndSetCentroids({
      endpoint: centroidsApiUrl,
    })
  }

  return null
}
